// extracted by mini-css-extract-plugin
export var marginNegative = "_7m-5 _7m-3 _7m-1";
export var marginPositive = "_7m-4 _7m-3 _7m-1";
export var modalContent = "_7m-6";
export var samplesTable = "_7m-8";
export var samplesTableContainer = "_7m-7";
export var statBox = "_7m-a";
export var tableCell = "_7m-1";
export var tableCellCenter = "_7m-2 _7m-1";
export var tableCellRight = "_7m-3 _7m-1";
export var tableHeader = "_7m-0";
export var trackingNumber = "_7m-9";